/**
 * Promo Bar - Native JS Implementation Clone
 * Handles native horizontal scrolling, arrow visibility, and drag-to-scroll
 */

(function () {
    function initPromoBar() {
        const container = document.querySelector('.promo-bar__container');
        if (!container) return;

        const slider = container.querySelector('.promo-bar__slider');
        const slides = Array.from(container.querySelectorAll('.promo-bar__item'));
        const prevArrowWrapper = container.querySelector('.promo-bar__arrow-wrapper--prev');
        const nextArrowWrapper = container.querySelector('.promo-bar__arrow-wrapper--next');
        const prevArrow = container.querySelector('.promo-bar__arrow--prev');
        const nextArrow = container.querySelector('.promo-bar__arrow--next');

        if (!slider || slides.length === 0) return;

        let currentIndex = 0;
        let isDesktop = false;
        let scrollTimeout = null;
        let isNavigating = false;

        // Drag state
        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;
        let hasDragged = false;
        let boundMouseMove = null;
        let boundMouseUp = null;

        const itemCount = parseInt(container.getAttribute('data-item-count')) || 0;

        function updateViewport() {
            // Match the 750px breakpoint used in our CSS
            isDesktop = window.innerWidth >= 750;
        }

        function getScrollPosition() {
            if (!slider || slides.length === 0) return { isAtStart: true, isAtEnd: true };
            const currentScroll = slider.scrollLeft;
            const maxScroll = slider.scrollWidth - slider.clientWidth;
            const threshold = 5;

            return {
                isAtStart: currentScroll <= threshold,
                isAtEnd: currentScroll >= maxScroll - threshold
            };
        }

        function updateArrowState(wrapper, shouldBeVisible) {
            if (!wrapper) return;
            wrapper.classList.remove('promo-bar__arrow-wrapper--visible', 'promo-bar__arrow-wrapper--hidden');
            if (shouldBeVisible) {
                wrapper.classList.add('promo-bar__arrow-wrapper--visible');
            } else {
                wrapper.classList.add('promo-bar__arrow-wrapper--hidden');
            }
        }

        function hideArrows() {
            if (prevArrowWrapper) prevArrowWrapper.style.display = 'none';
            if (nextArrowWrapper) nextArrowWrapper.style.display = 'none';
        }

        function updateArrowVisibility() {
            if (!prevArrowWrapper || !nextArrowWrapper) return;

            if (!isDesktop) {
                prevArrowWrapper.style.display = 'none';
                nextArrowWrapper.style.display = 'none';
                return;
            }

            // Only show arrows if there are 3 or more items
            if (itemCount < 3) {
                hideArrows();
                return;
            }

            const { isAtStart, isAtEnd } = getScrollPosition();
            updateArrowState(prevArrowWrapper, !isAtStart);
            updateArrowState(nextArrowWrapper, !isAtEnd);
        }

        function calculateCurrentIndex() {
            if (!slider || slides.length === 0) return;
            const currentScroll = slider.scrollLeft;
            const slideWidth = slides[0].offsetWidth;
            const gap = parseInt(window.getComputedStyle(slider).gap) || 20;
            const slideWithGap = slideWidth + gap;
            const newIndex = Math.round(currentScroll / slideWithGap);
            currentIndex = Math.max(0, Math.min(newIndex, slides.length - 1));
        }

        function getSlidesPerPage() {
            return isDesktop ? (itemCount === 1 ? 1 : 2) : 1;
        }

        function updateArrowsForTargetPosition(targetIndex) {
            if (!prevArrowWrapper || !nextArrowWrapper || !isDesktop || itemCount < 3) return;
            const slidesPerPage = getSlidesPerPage();
            const maxIndex = Math.max(0, slides.length - slidesPerPage);

            const willBeAtStart = targetIndex === 0;
            const willBeAtEnd = targetIndex >= maxIndex;

            if (willBeAtStart) {
                prevArrowWrapper.classList.remove('promo-bar__arrow-wrapper--visible');
                prevArrowWrapper.classList.add('promo-bar__arrow-wrapper--hidden');
            } else {
                prevArrowWrapper.classList.remove('promo-bar__arrow-wrapper--hidden');
                prevArrowWrapper.classList.add('promo-bar__arrow-wrapper--visible');
            }

            if (willBeAtEnd) {
                nextArrowWrapper.classList.remove('promo-bar__arrow-wrapper--visible');
                nextArrowWrapper.classList.add('promo-bar__arrow-wrapper--hidden');
            } else {
                nextArrowWrapper.classList.remove('promo-bar__arrow-wrapper--hidden');
                nextArrowWrapper.classList.add('promo-bar__arrow-wrapper--visible');
            }
        }

        function scrollToSlide(index) {
            if (!slider || !slides[index]) return;
            const slideWidth = slides[0].offsetWidth;
            const gap = parseInt(window.getComputedStyle(slider).gap) || 20;
            const scrollPosition = index * (slideWidth + gap);

            slider.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });
        }

        function navigatePrev(e) {
            if (e) e.preventDefault();
            if (!slider || currentIndex <= 0) return;

            const targetIndex = Math.max(0, currentIndex - getSlidesPerPage());
            isNavigating = true;
            updateArrowsForTargetPosition(targetIndex);
            scrollToSlide(targetIndex);

            setTimeout(() => {
                isNavigating = false;
                currentIndex = targetIndex;
            }, 350);
        }

        function navigateNext(e) {
            if (e) e.preventDefault();
            if (!slider || slides.length === 0) return;

            const slidesPerPage = getSlidesPerPage();
            const maxIndex = Math.max(0, slides.length - slidesPerPage);
            const targetIndex = Math.min(maxIndex, currentIndex + slidesPerPage);

            isNavigating = true;
            updateArrowsForTargetPosition(targetIndex);
            scrollToSlide(targetIndex);

            setTimeout(() => {
                isNavigating = false;
                currentIndex = targetIndex;
            }, 350);
        }

        function onScroll() {
            if (!slider || slides.length === 0 || isNavigating) return;

            const { isAtStart, isAtEnd } = getScrollPosition();
            if (isAtStart || isAtEnd) {
                calculateCurrentIndex();
                updateArrowVisibility();
            }

            if (scrollTimeout) clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                if (!isNavigating) {
                    calculateCurrentIndex();
                    updateArrowVisibility();
                }
            }, 50);
        }

        function onResize() {
            updateViewport();
            updateArrowVisibility();
        }

        // Drag functionality
        function addDragListeners() {
            boundMouseMove = onMouseMove.bind(this);
            boundMouseUp = onMouseUp.bind(this);
            document.addEventListener("mousemove", boundMouseMove);
            document.addEventListener("mouseup", boundMouseUp);
            document.addEventListener("mouseleave", boundMouseUp);
        }

        function removeDragListeners() {
            if (boundMouseMove) {
                document.removeEventListener("mousemove", boundMouseMove);
                boundMouseMove = null;
            }
            if (boundMouseUp) {
                document.removeEventListener("mouseup", boundMouseUp);
                document.removeEventListener("mouseleave", boundMouseUp);
                boundMouseUp = null;
            }
        }

        function onMouseDown(e) {
            // Only allow left click drag on desktop, and ignore clicks on links/buttons
            if (!isDesktop || e.button !== 0 || e.target.closest("a, button")) return;

            isDragging = true;
            hasDragged = false;
            startX = e.clientX;
            scrollLeft = slider.scrollLeft;

            addDragListeners();
            document.body.style.userSelect = "none";
            slider.style.cursor = "grabbing";
            e.preventDefault();
        }

        function onMouseMove(e) {
            if (!isDragging) return;
            e.preventDefault();

            const walk = (e.clientX - startX) * 2.5; // Scroll drag friction
            const newScrollLeft = scrollLeft - walk;
            const maxScroll = slider.scrollWidth - slider.clientWidth;

            slider.scrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));

            if (Math.abs(walk) > 2) {
                hasDragged = true;
            }
        }

        function onMouseUp(e) {
            if (!isDragging) return;

            isDragging = false;
            removeDragListeners();
            document.body.style.userSelect = "";
            slider.style.cursor = "";

            if (hasDragged) {
                setTimeout(() => { hasDragged = false; }, 50);
            }
        }

        // Bind events
        if (slider) {
            slider.addEventListener('scroll', onScroll);
            slider.addEventListener('mousedown', onMouseDown);

            // Prevent link clicks if we just dragged
            slider.addEventListener('click', function (e) {
                if (hasDragged) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, true);
        }

        window.addEventListener('resize', onResize);

        if (prevArrow && nextArrow) {
            prevArrow.addEventListener('click', navigatePrev);
            nextArrow.addEventListener('click', navigateNext);
        }

        // Initialize state
        updateViewport();
        currentIndex = 0;

        if (itemCount >= 3) {
            setTimeout(() => {
                updateArrowVisibility();
            }, 100);
        } else {
            hideArrows();
        }
    }

    // Run on layout load
    document.addEventListener('DOMContentLoaded', initPromoBar);

    // Also run immediately in case DOM is already loaded
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        initPromoBar();
    }
})();
